import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { TreeNode } from 'primeng/api';
import { ILocationNode } from 'src/app/core/interfaces';

@Component({
    selector: 'dk-tree-select',
    templateUrl: './dk-tree-select.component.html',
    styleUrl: './dk-tree-select.component.scss',
    standalone: false
})
export class DkTreeSelectComponent implements OnInit, OnChanges {
  /* -------------------------------------------------------------------------- */
  /*                                    label                                 */
  /* ------------------------------------------------------------------------ */
  @Input() public label: string;

  // /* -------------------------------------------------------------------------- */
  // /*                               bootstrap grid                               */
  // /* -------------------------------------------------------------------------- */

  @Input() public col = '12'; // mobile
  @Input() public sm = '12'; // small
  @Input() public md = '12'; // medium
  @Input() public lg = '12'; // medium
  @Input() public xl = '12'; // extra large

  @Input() public has_my3 = false;
  @Input() public has_mb3 = false;

  /* -------------------------------------------------------------------------- */
  /*                                    form                                    */
  /* -------------------------------------------------------------------------- */

  @Input() public formGroup: FormGroup;
  @Input() public controlName: string;
  @Input() public autocomplete = 'off';
  @Input() public type = 'text';
  @Input() public placeholder = '';
  @Input() public disabled = false;
  @Input() public autoFocus = false;
  @Input() appendTo = 'body';

  @Input() id: string; // the id of options
  @Input() optionLabel: string; // the label of option that we see
  @Input() imageBaseSrc: string;
  @Input() imageKey: string;
  @Input() imageExtension: string;
  @Input() filter = false;
  @Input() options: any = [];
  @Input() loading = false;
  @Input() emptyMessage = 'Sonuç bulunamadı'; // if options were empty
  @Input() emptyFilterMessage = 'Sonuç bulunamadı'; // if the result of filter was empty
  @Input() scrollHeight = '250px';

  @Output() onChangeEvent = new EventEmitter();
  @Output() onNodeExpand = new EventEmitter();
  @Output() onNodeCollapse = new EventEmitter();
  @Output() onNodeSelect = new EventEmitter();
  @Output() onNodeUnselect = new EventEmitter();

  @Input() nodes!: ILocationNode[];

  selectedNodes: any;

  /* -------------------------------------------------------------------------- */
  /*                                 constructor                                */
  /* -------------------------------------------------------------------------- */
  constructor(
    private cdref: ChangeDetectorRef,
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['disabled'] && this.control) {
      if (this.disabled) {
        this.control.disable();
      } else {
        this.control.enable();
      }
    }
  }

  ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'col-' + this.col);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-sm-' + this.sm);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-md-' + this.md);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-lg-' + this.lg);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-xl-' + this.xl);
  }

  getSelectedNodeLabels(selectedNodes: TreeNode[] | ILocationNode[]) {
    if (!(selectedNodes?.length > 0)) {
      return null;
    }
    return selectedNodes
      ?.map((e: any) => e.label)
      .filter((e: string) => e != '')
      .join(', ');
  }

  get control(): AbstractControl {
    if (this.formGroup && this.controlName) {
      return this.formGroup?.controls[this.controlName];
    }
    return null;
  }

  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }

  onNodeCollapseFn(node: any) {
    if (node.children?.length > 0) {
      for (const child of node.children) {
        child.expanded = false;
        this.onNodeCollapseFn(child);
      }
    }

    this.onNodeCollapse.emit(node);
  }

  onShow() {
    if (this.nodes?.length > 0) {
      this.onNodeCollapseFn(this.nodes[0]);
    }
  }

  get required(): boolean {
    if (!this.control?.validator) {
      return false;
    }

    const validator = this.control.validator({} as AbstractControl);
    return validator?.['required'];
  }

  get screenHight() {
    return document.body.clientHeight;
  }
}
